import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaFootnoteUtility from '@sparta.global.utilities/sparta-footnote-utility/dist/es6.js';
import '@sparta.global.utilities/sparta-global-functions-utility/dist/es6.js';
import spartaMediaQueryUtility from '@sparta.global.utilities/sparta-mediaquery-utility/dist/es6.js';
import spartaSqueezeboxUtility from '@sparta.global.utilities/sparta-squeezebox-utility/dist/es6.js';
import spartaStoreUtility from '@sparta.global.utilities/sparta-store-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { spartaContentManagerHelper } from '@sparta.global.helpers/content-manager-helper/dist/es6.js';
import { squeezebox } from '@sparta.global.helpers/squeezebox-helper/dist/es6.js';
import { link, layerContent } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { or, compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { button } from '@sparta.global.helpers/button-helper/dist/es6.js';

const Template$8 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "auth";
},"3":function(container,depth0,helpers,partials,data) {
    return "unauth";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"footnote"),depth0,{"name":"footnote","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"footerActions") : stack1)) != null ? lookupProperty(stack1,"active") : stack1),"!==",false,{"name":"compare","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":4},"end":{"line":16,"column":16}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"footerQuickLink") : stack1),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":4},"end":{"line":23,"column":11}}})) != null ? stack1 : "");
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"actions"),depth0,{"name":"actions","data":data,"indent":"      ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"or")||(depth0 && lookupProperty(depth0,"or"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLinkOrder") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLinkOrder") : stack1),{"name":"or","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":6},"end":{"line":22,"column":13}}})) != null ? stack1 : "");
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"footer-quicklinks"),depth0,{"name":"footer-quicklinks","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"legal"),depth0,{"name":"legal","hash":{"partial":"partials/legal-content"},"data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"footerQuickLink") : stack1),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":33,"column":4},"end":{"line":37,"column":11}}})) != null ? stack1 : "");
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"or")||(depth0 && lookupProperty(depth0,"or"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"secondaryLinkOrder") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"secondaryLinkOrder") : stack1),{"name":"or","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":6},"end":{"line":36,"column":13}}})) != null ? stack1 : "");
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"footer-quicklinks"),depth0,{"name":"footer-quicklinks","hash":{"secondary":true},"data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"19":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"breadcrumbs"),depth0,{"name":"breadcrumbs","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"21":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"legal-expanded"),depth0,{"name":"legal-expanded","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"23":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"power-footer"),depth0,{"name":"power-footer","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"25":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"footerQuickLink") : stack1),{"name":"if","hash":{},"fn":container.program(26, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":64,"column":10},"end":{"line":66,"column":17}}})) != null ? stack1 : "");
},"26":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"footer-quicklinks"),depth0,{"name":"footer-quicklinks","data":data,"indent":"            ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"28":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"enableSocialMedia") : stack1),{"name":"if","hash":{},"fn":container.program(29, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":72,"column":10},"end":{"line":78,"column":17}}})) != null ? stack1 : "");
},"29":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"children") : depth0)) != null ? lookupProperty(stack1,"globalSocialModule") : stack1),{"name":"if","hash":{},"fn":container.program(30, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":73,"column":12},"end":{"line":77,"column":19}}})) != null ? stack1 : "");
},"30":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <div class=\"text-center\">\r\n                "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"children") : depth0)) != null ? lookupProperty(stack1,"globalSocialModule") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n              </div>\r\n";
},"32":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div class=\"text-center\">\r\n            <p class=\"footer__legal-text\">\r\n              "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"bacFooterFDIC") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"bacFooterEhl") : stack1),{"name":"if","hash":{},"fn":container.program(33, data, 0),"inverse":container.program(35, data, 0),"data":data,"loc":{"start":{"line":86,"column":14},"end":{"line":90,"column":21}}})) != null ? stack1 : "")
    + "            </p>\r\n            <p class=\"footer__copyright-text\">\r\n              "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"global") : depth0)) != null ? lookupProperty(stack1,"globalText") : stack1)) != null ? lookupProperty(stack1,"copy") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n              "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"global") : depth0)) != null ? lookupProperty(stack1,"globalText") : stack1)) != null ? lookupProperty(stack1,"year") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n              "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"bacFooterBac") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"bacFooterAllRightsReserved") : stack1),{"name":"if","hash":{},"fn":container.program(37, data, 0),"inverse":container.program(39, data, 0),"data":data,"loc":{"start":{"line":96,"column":14},"end":{"line":100,"column":21}}})) != null ? stack1 : "")
    + "            </p>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"bacFooterPatent") : stack1),{"name":"if","hash":{},"fn":container.program(41, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":102,"column":12},"end":{"line":106,"column":19}}})) != null ? stack1 : "")
    + "          </div>\r\n";
},"33":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"bacFooterEhl") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"35":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"bacFooterEhl") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"37":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"bacFooterAllRightsReserved") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"39":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"bacFooterAllRightsReserved") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n";
},"41":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <p class=\"footer__patent-text footer-last\">\r\n                "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"bacFooterPatent") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n            </p>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<footer\r\n  class=\"footer footer--"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"skin") : stack1), depth0))
    + " global-footer-spacing--"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"setFooterSpacingTop") : stack1), depth0))
    + "\"\r\n  data-mode=\"footer--"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"mode") : stack1),"==","auth",{"name":"compare","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":3,"column":21},"end":{"line":3,"column":87}}})) != null ? stack1 : "")
    + "\"\r\n  role=\"contentinfo\"\r\n>\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"footnoteSection") : stack1),"!==",false,{"name":"compare","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":2},"end":{"line":9,"column":14}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"mode") : stack1),"==","auth",{"name":"compare","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":2},"end":{"line":24,"column":14}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"legalSection") : stack1),"!==",false,{"name":"compare","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":2},"end":{"line":29,"column":14}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"mode") : stack1),"==","auth",{"name":"compare","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":32,"column":2},"end":{"line":38,"column":14}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"breadcrumbs") : stack1),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":42,"column":2},"end":{"line":44,"column":9}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"expandedLegalSection") : stack1),{"name":"if","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":47,"column":2},"end":{"line":49,"column":9}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"powerFooterSection") : stack1),{"name":"if","hash":{},"fn":container.program(23, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":52,"column":2},"end":{"line":54,"column":9}}})) != null ? stack1 : "")
    + "\r\n  <div class=\"\r\n    footer__bottom\r\n    footer__bottom--"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"mode") : stack1),"==","auth",{"name":"compare","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":58,"column":20},"end":{"line":58,"column":86}}})) != null ? stack1 : "")
    + "\r\n  \">\r\n    <div class=\"row\">\r\n      <div class=\"column\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"mode") : stack1),"==","unauth",{"name":"compare","hash":{},"fn":container.program(25, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":63,"column":8},"end":{"line":67,"column":20}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"mode") : stack1),"==","unauth",{"name":"compare","hash":{},"fn":container.program(28, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":70,"column":8},"end":{"line":79,"column":20}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"copyrightSection") : stack1),{"name":"if","hash":{},"fn":container.program(32, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":82,"column":8},"end":{"line":108,"column":15}}})) != null ? stack1 : "")
    + "      </div>\r\n    </div>\r\n  </div>\r\n</footer>\r\n<style type=\"text/css\">\r\n  .global-footer-module .footer__bottom--unauth .equalhousing {\r\n    background-image: url('"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"equalHousingLender") : stack1)) != null ? lookupProperty(stack1,"iconWhite") : stack1), depth0))
    + "');\r\n  }\r\n  .global-footer-module .footer__bottom--auth .equalhousing {\r\n    background-image: url('"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"equalHousingLender") : stack1)) != null ? lookupProperty(stack1,"iconLink") : stack1), depth0))
    + "');\r\n  }\r\n</style>\r\n";
},"usePartial":true,"useData":true});
const renderTemplate$8 = function (data, options) {
  return Template$8(data, options);
};

const Template$7 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "          <div class=\"footer__actions--area\">\r\n            Secure Area\r\n          </div>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div class=\"footer__actions--language footer__list-has-pipes\">\r\n            <ul class=\"footer__actions-language-list\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerActions_language") : stack1),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":14},"end":{"line":47,"column":23}}})) != null ? stack1 : "")
    + "            </ul>\r\n          </div>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"key")),"!=",((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"language")),{"name":"compare","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":16},"end":{"line":46,"column":28}}})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <li><a\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ID") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":20},"end":{"line":23,"column":27}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"URL") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":20},"end":{"line":26,"column":27}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"CLASS") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":20},"end":{"line":29,"column":27}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"key")),"==",((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"language")),{"name":"compare","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":32,"column":20},"end":{"line":34,"column":32}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"onClick") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":37,"column":20},"end":{"line":39,"column":27}}})) != null ? stack1 : "")
    + "                  >\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"nicename") : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":42,"column":20},"end":{"line":44,"column":27}}})) != null ? stack1 : "")
    + "                  </a></li>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"ID") : depth0), depth0))
    + "\"\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      href=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"URL") : depth0), depth0))
    + "\"\r\n";
},"10":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      class=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"CLASS") : depth0), depth0))
    + "\"\r\n";
},"12":function(container,depth0,helpers,partials,data) {
    return "                      disabled=\"true\"\r\n";
},"14":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      onclick=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"onClick") : depth0), depth0))
    + "\"\r\n";
},"16":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"nicename") : depth0), depth0))
    + "\r\n";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"authentication") : stack1),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":55,"column":10},"end":{"line":108,"column":17}}})) != null ? stack1 : "");
},"19":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"authentication") : stack1)) != null ? lookupProperty(stack1,"content") : stack1),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":56,"column":12},"end":{"line":107,"column":19}}})) != null ? stack1 : "");
},"20":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <div class=\"\r\n                footer__actions--authentication\r\n                footer__list-has-pipes\r\n\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"footerActions") : stack1),"!==",false,{"name":"compare","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":63,"column":16},"end":{"line":67,"column":28}}})) != null ? stack1 : "")
    + "              \">\r\n                <ul>\r\n                  <li><a\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"authentication") : stack1)) != null ? lookupProperty(stack1,"ID") : stack1),{"name":"if","hash":{},"fn":container.program(24, data, 0),"inverse":container.program(26, data, 0),"data":data,"loc":{"start":{"line":73,"column":20},"end":{"line":77,"column":27}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"authentication") : stack1)) != null ? lookupProperty(stack1,"URL") : stack1),{"name":"if","hash":{},"fn":container.program(28, data, 0),"inverse":container.program(30, data, 0),"data":data,"loc":{"start":{"line":80,"column":20},"end":{"line":84,"column":27}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"authentication") : stack1)) != null ? lookupProperty(stack1,"CLASS") : stack1),{"name":"if","hash":{},"fn":container.program(32, data, 0),"inverse":container.program(34, data, 0),"data":data,"loc":{"start":{"line":87,"column":20},"end":{"line":91,"column":27}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"authentication") : stack1)) != null ? lookupProperty(stack1,"onClick") : stack1),{"name":"if","hash":{},"fn":container.program(36, data, 0),"inverse":container.program(38, data, 0),"data":data,"loc":{"start":{"line":94,"column":20},"end":{"line":98,"column":27}}})) != null ? stack1 : "")
    + "                  >\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"authentication") : stack1)) != null ? lookupProperty(stack1,"content") : stack1),{"name":"if","hash":{},"fn":container.program(40, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":101,"column":20},"end":{"line":103,"column":27}}})) != null ? stack1 : "")
    + "                  </a></li>\r\n                </ul>\r\n              </div>\r\n";
},"21":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"objLengthGreaterEqualThan")||(depth0 && lookupProperty(depth0,"objLengthGreaterEqualThan"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerActions_language") : stack1),1,((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"language")),{"name":"objLengthGreaterEqualThan","hash":{},"data":data,"loc":{"start":{"line":64,"column":24},"end":{"line":64,"column":103}}}),{"name":"if","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":64,"column":18},"end":{"line":66,"column":25}}})) != null ? stack1 : "");
},"22":function(container,depth0,helpers,partials,data) {
    return "                    footer__actions-pipe\r\n";
},"24":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      id=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"authentication") : stack1)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\"\r\n";
},"26":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      id=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"authentication") : stack1)) != null ? lookupProperty(stack1,"ID") : stack1), depth0))
    + "\"\r\n";
},"28":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      href=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"authentication") : stack1)) != null ? lookupProperty(stack1,"URL") : stack1), depth0))
    + "\"\r\n";
},"30":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      href=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"authentication") : stack1)) != null ? lookupProperty(stack1,"URL") : stack1), depth0))
    + "\"\r\n";
},"32":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"authentication") : stack1)) != null ? lookupProperty(stack1,"CLASS") : stack1), depth0))
    + "\"\r\n";
},"34":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      class=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"authentication") : stack1)) != null ? lookupProperty(stack1,"CLASS") : stack1), depth0))
    + "\"\r\n";
},"36":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      onclick=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"authentication") : stack1)) != null ? lookupProperty(stack1,"onClick") : stack1), depth0))
    + "\"\r\n";
},"38":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      onclick=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"authentication") : stack1)) != null ? lookupProperty(stack1,"onClick") : stack1), depth0))
    + "\"\r\n";
},"40":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"authentication") : stack1)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
    + "\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"footer__actions\">\r\n  <div class=\"row\">\r\n    <div class=\"column\">\r\n      <div class=\"footer__actions-flex\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"footerActions") : stack1)) != null ? lookupProperty(stack1,"secure_area") : stack1),"!==",false,{"name":"compare","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":8},"end":{"line":10,"column":20}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"footerActions") : stack1),"!==",false,{"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":8},"end":{"line":50,"column":20}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"footerActions") : stack1)) != null ? lookupProperty(stack1,"authentication") : stack1),"!==",false,{"name":"compare","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":54,"column":8},"end":{"line":109,"column":20}}})) != null ? stack1 : "")
    + "      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n";
},"useData":true});
const renderTemplate$7 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$7(data, options);
};

const Template$6 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li itemprop=\"itemListElement\" itemscope itemtype=\"https://schema.org/ListItem\">\r\n              <a itemprop=\"item\" id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"ID") : depth0), depth0))
    + "\" href=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"URL") : depth0), depth0))
    + "\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"actionType") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":70},"end":{"line":11,"column":188}}})) != null ? stack1 : "")
    + ">\r\n                <span itemprop=\"name\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"content") : depth0), depth0)) != null ? stack1 : "")
    + "</span>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"actionType") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":16},"end":{"line":15,"column":23}}})) != null ? stack1 : "")
    + "              </a>\r\n\r\n              <meta itemprop=\"position\" content=\""
    + container.escapeExpression((lookupProperty(helpers,"sum")||(depth0 && lookupProperty(depth0,"sum"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"index")),1,{"name":"sum","hash":{},"data":data,"loc":{"start":{"line":19,"column":49},"end":{"line":19,"column":65}}}))
    + "\" />\r\n            </li>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    return " class=\"spa-ui-layer-link spa-fn\" data-options='{\"interstitialType\":\"language-change\"}' ";
},"4":function(container,depth0,helpers,partials,data) {
    return "                  <span class=\"spa-ada-text ada-hidden\">&nbsp;layer</span>\r\n";
},"6":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"breadcrumbSection") : stack1)) != null ? lookupProperty(stack1,"sectionLinks") : stack1),{"name":"each","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":12},"end":{"line":39,"column":21}}})) != null ? stack1 : "");
},"7":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"key")),"==",((stack1 = (depths[1] != null ? lookupProperty(depths[1],"module") : depths[1])) != null ? lookupProperty(stack1,"breadcrumbsSectionName") : stack1),{"name":"compare","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":14},"end":{"line":38,"column":26}}})) != null ? stack1 : "");
},"8":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <li itemprop=\"itemListElement\" itemscope itemtype=\"https://schema.org/ListItem\">\r\n                  <a itemprop=\"item\" id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"ID") : depth0), depth0))
    + "\" href=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"URL") : depth0), depth0))
    + "\">\r\n                    <span itemprop=\"name\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"content") : depth0), depth0)) != null ? stack1 : "")
    + "</span>\r\n                  </a>\r\n\r\n                  <meta\r\n                    itemprop=\"position\"\r\n                    content=\""
    + container.escapeExpression((lookupProperty(helpers,"sum")||(depth0 && lookupProperty(depth0,"sum"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"index")),((stack1 = ((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"siteFooter1") : depths[1])) != null ? lookupProperty(stack1,"breadcrumbSection") : stack1)) != null ? lookupProperty(stack1,"links") : stack1)) != null ? lookupProperty(stack1,"length") : stack1),1,{"name":"sum","hash":{},"data":data,"loc":{"start":{"line":35,"column":29},"end":{"line":35,"column":91}}}))
    + "\"\r\n                  />\r\n                </li>\r\n";
},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"sitePageTitles") : depth0)) != null ? lookupProperty(stack1,"pageTitles") : stack1),{"name":"each","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":44,"column":12},"end":{"line":65,"column":21}}})) != null ? stack1 : "");
},"11":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":45,"column":14},"end":{"line":64,"column":23}}})) != null ? stack1 : "");
},"12":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"key")),"==",((stack1 = (depths[2] != null ? lookupProperty(depths[2],"page") : depths[2])) != null ? lookupProperty(stack1,"pageID") : stack1),{"name":"compare","hash":{},"fn":container.program(13, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":46,"column":16},"end":{"line":63,"column":28}}})) != null ? stack1 : "");
},"13":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <li itemprop=\"itemListElement\" itemscope itemtype=\"https://schema.org/ListItem\">\r\n                    <a itemprop=\"item\" id=\"footer_breadcrumb_"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"key") || (data && lookupProperty(data,"key"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"key","hash":{},"data":data,"loc":{"start":{"line":48,"column":61},"end":{"line":48,"column":69}}}) : helper)))
    + "\" href=\".\">\r\n                      <span itemprop=\"name\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"default") : depth0), depth0)) != null ? stack1 : "")
    + "</span>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"globalFooter1"))) && lookupProperty(stack1,"adaCurrentPage")),{"name":"if","hash":{},"fn":container.program(14, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":50,"column":22},"end":{"line":52,"column":29}}})) != null ? stack1 : "")
    + "                    </a>\r\n\r\n                    <meta\r\n                      itemprop=\"position\"\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depths[2] != null ? lookupProperty(depths[2],"siteFooter1") : depths[2])) != null ? lookupProperty(stack1,"breadcrumbSection") : stack1),{"name":"with","hash":{},"fn":container.program(16, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":58,"column":22},"end":{"line":60,"column":31}}})) != null ? stack1 : "")
    + "                    />\r\n                  </li>\r\n";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <span class=\"ada-hidden\">&nbsp;"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"globalFooter1"))) && lookupProperty(stack1,"adaCurrentPage")), depth0))
    + "</span>\r\n";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        content=\""
    + container.escapeExpression((lookupProperty(helpers,"sum")||(depth0 && lookupProperty(depth0,"sum"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"sectionLinks") : depth0)) != null ? lookupProperty(stack1,"length") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"links") : depth0)) != null ? lookupProperty(stack1,"length") : stack1),1,{"name":"sum","hash":{},"data":data,"loc":{"start":{"line":59,"column":33},"end":{"line":59,"column":75}}}))
    + "\"\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n<div class=\"footer__breadcrumbs "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"breadcrumbsClass") : stack1), depth0))
    + "\">\r\n  <div class=\"row\">\r\n    <div class=\"column\">\r\n      <nav role=\"navigation\" class=\"row\" aria-label=\"Breadcrumb\">\r\n        <ol itemscope itemtype=\"https://schema.org/BreadcrumbList\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"breadcrumbSection") : stack1)) != null ? lookupProperty(stack1,"links") : stack1),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":10},"end":{"line":21,"column":19}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"breadcrumbSection") : stack1)) != null ? lookupProperty(stack1,"sectionLinks") : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":10},"end":{"line":40,"column":17}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"breadcrumbsCurrentPage") : stack1),"!=",false,{"name":"compare","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":43,"column":10},"end":{"line":66,"column":22}}})) != null ? stack1 : "")
    + "        </ol>\r\n      </nav>\r\n    </div>\r\n  </div>\r\n</div>\r\n";
},"useData":true,"useDepths":true});
const renderTemplate$6 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$6(data, options);
};

const Template$5 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "auth";
},"3":function(container,depth0,helpers,partials,data) {
    return "unauth";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <nav\r\n          role=\"navigation\"\r\n          class=\"\r\n            footer__"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"secondaryLinkOrder") : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(8, data, 0),"data":data,"loc":{"start":{"line":12,"column":20},"end":{"line":12,"column":82}}})) != null ? stack1 : "")
    + "-links\r\n            footer__list-has-pipes\r\n          \"\r\n          aria-label=\"Footer navigation links\"\r\n        >\r\n          <ul>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"footerModuleLinksHelper")||(depth0 && lookupProperty(depth0,"footerModuleLinksHelper"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"secondaryLinkOrder") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"secondaryLinkOrder") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1),{"name":"footerModuleLinksHelper","hash":{},"data":data,"loc":{"start":{"line":18,"column":20},"end":{"line":24,"column":13}}}),{"name":"each","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":12},"end":{"line":30,"column":21}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"footerModuleLinksHelper")||(depth0 && lookupProperty(depth0,"footerModuleLinksHelper"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"secondaryLinkOrder") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"secondaryLinkOrder") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1),{"name":"footerModuleLinksHelper","hash":{},"data":data,"loc":{"start":{"line":33,"column":20},"end":{"line":39,"column":13}}}),{"name":"each","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":33,"column":12},"end":{"line":43,"column":21}}})) != null ? stack1 : "")
    + "          </ul>\r\n        </nav>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "bottom";
},"8":function(container,depth0,helpers,partials,data) {
    return "top";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ID") : depth0),"===","footer_bofa_CCPA",{"name":"compare","hash":{},"fn":container.program(11, data, 0),"inverse":container.program(18, data, 0),"data":data,"loc":{"start":{"line":25,"column":16},"end":{"line":29,"column":28}}})) != null ? stack1 : "");
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <li "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"last")),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":22},"end":{"line":26,"column":59}}})) != null ? stack1 : "")
    + " id=\"footer_CCPA\">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"link","hash":{},"data":data,"loc":{"start":{"line":26,"column":77},"end":{"line":26,"column":92}}})) != null ? stack1 : "")
    + "<img id=\"pillImage\" alt=\"\" role=\"img\" src=\""
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"mode")),"==","auth",{"name":"compare","hash":{},"fn":container.program(14, data, 0),"inverse":container.program(16, data, 0),"data":data,"loc":{"start":{"line":26,"column":135},"end":{"line":26,"column":230}}})) != null ? stack1 : "")
    + "\"/></li>\r\n";
},"12":function(container,depth0,helpers,partials,data) {
    return "class=\"last-link\"";
},"14":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"icon") : depth0), depth0));
},"16":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"icon_unauth") : depth0), depth0));
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <li "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"last")),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":18},"end":{"line":28,"column":55}}})) != null ? stack1 : "")
    + ">"
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"link","hash":{},"data":data,"loc":{"start":{"line":28,"column":56},"end":{"line":28,"column":71}}})) != null ? stack1 : "")
    + "</li>\r\n";
},"20":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"layer") : depth0),{"name":"with","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":40,"column":14},"end":{"line":42,"column":23}}})) != null ? stack1 : "");
},"21":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                "
    + ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"layerContent","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":41,"column":16},"end":{"line":41,"column":73}}})) != null ? stack1 : "")
    + "\r\n";
},"22":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"content") : depth0), depth0)) != null ? stack1 : "");
},"24":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <nav\r\n          role=\"navigation\"\r\n          class=\"\r\n            footer__"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLinkOrder") : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(8, data, 0),"data":data,"loc":{"start":{"line":50,"column":20},"end":{"line":50,"column":79}}})) != null ? stack1 : "")
    + "-links\r\n            footer__list-has-pipes\r\n          \"\r\n          aria-label=\"Footer navigation links\"\r\n        >\r\n          <ul>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"footerModuleLinksHelper")||(depth0 && lookupProperty(depth0,"footerModuleLinksHelper"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLinkOrder") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLinkOrder") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1),{"name":"footerModuleLinksHelper","hash":{},"data":data,"loc":{"start":{"line":56,"column":20},"end":{"line":62,"column":13}}}),{"name":"each","hash":{},"fn":container.program(25, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":56,"column":12},"end":{"line":68,"column":21}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"footerModuleLinksHelper")||(depth0 && lookupProperty(depth0,"footerModuleLinksHelper"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLinkOrder") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLinkOrder") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1),{"name":"footerModuleLinksHelper","hash":{},"data":data,"loc":{"start":{"line":71,"column":20},"end":{"line":77,"column":13}}}),{"name":"each","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":71,"column":12},"end":{"line":81,"column":21}}})) != null ? stack1 : "")
    + "          </ul>\r\n        </nav>\r\n";
},"25":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"ID") : depth0),"===","footer_bofa_CCPA",{"name":"compare","hash":{},"fn":container.program(26, data, 0),"inverse":container.program(31, data, 0),"data":data,"loc":{"start":{"line":63,"column":16},"end":{"line":67,"column":28}}})) != null ? stack1 : "");
},"26":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <li "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"last")),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":64,"column":22},"end":{"line":64,"column":59}}})) != null ? stack1 : "")
    + " id=\"footer_CCPA\">"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"==","button",{"name":"compare","hash":{},"fn":container.program(27, data, 0),"inverse":container.program(29, data, 0),"data":data,"loc":{"start":{"line":64,"column":77},"end":{"line":64,"column":163}}})) != null ? stack1 : "")
    + "<img id=\"pillImage\" alt=\"\" role=\"img\" src=\""
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"module"))) && lookupProperty(stack1,"mode")),"==","auth",{"name":"compare","hash":{},"fn":container.program(14, data, 0),"inverse":container.program(16, data, 0),"data":data,"loc":{"start":{"line":64,"column":206},"end":{"line":64,"column":301}}})) != null ? stack1 : "")
    + "\"/></li>\r\n";
},"27":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression((lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"button","hash":{},"data":data,"loc":{"start":{"line":64,"column":113},"end":{"line":64,"column":128}}}));
},"29":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"link","hash":{},"data":data,"loc":{"start":{"line":64,"column":136},"end":{"line":64,"column":151}}})) != null ? stack1 : "");
},"31":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <li "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(data && lookupProperty(data,"last")),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":66,"column":18},"end":{"line":66,"column":55}}})) != null ? stack1 : "")
    + ">"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"==","button",{"name":"compare","hash":{},"fn":container.program(27, data, 0),"inverse":container.program(29, data, 0),"data":data,"loc":{"start":{"line":66,"column":56},"end":{"line":66,"column":142}}})) != null ? stack1 : "")
    + "</li>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"\r\n  footer__links\r\n  footer__links--"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"mode") : stack1),"==","auth",{"name":"compare","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":3,"column":17},"end":{"line":3,"column":83}}})) != null ? stack1 : "")
    + "\r\n  "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"footerQuickLinkClass") : stack1), depth0))
    + "\r\n\">\r\n  <div class=\"row\">\r\n    <div class=\"column\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"secondary") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(24, data, 0),"data":data,"loc":{"start":{"line":8,"column":6},"end":{"line":84,"column":13}}})) != null ? stack1 : "")
    + "    </div>\r\n  </div>\r\n</div>\r\n";
},"useData":true});
const renderTemplate$5 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$5(data, options);
};

const Template$4 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footnoteSection") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":6,"column":2},"end":{"line":10,"column":9}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    "
    + container.escapeExpression((lookupProperty(helpers,"squeezebox")||(depth0 && lookupProperty(depth0,"squeezebox"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"partials") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footnoteSection") : stack1),{"name":"squeezebox","hash":{},"data":data,"loc":{"start":{"line":7,"column":4},"end":{"line":7,"column":55}}}))
    + "\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    "
    + container.escapeExpression((lookupProperty(helpers,"squeezebox")||(depth0 && lookupProperty(depth0,"squeezebox"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"partials") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"footnoteSection") : stack1),{"name":"squeezebox","hash":{},"data":data,"loc":{"start":{"line":9,"column":4},"end":{"line":9,"column":57}}}))
    + "\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "  <div class=\"hidden\">\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    return "  <div id=\"footnoteSection\" class=\"footnote-section__panel\">\r\n    <div class=\"row\">\r\n      <div class=\"column\">\r\n";
},"10":function(container,depth0,helpers,partials,data) {
    return "  </div>\r\n";
},"12":function(container,depth0,helpers,partials,data) {
    return "      </div>\r\n    </div>\r\n  </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"footnoteSectionToggleable") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":0},"end":{"line":11,"column":7}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"footnoteSectionToggleable") : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(8, data, 0),"data":data,"loc":{"start":{"line":14,"column":0},"end":{"line":20,"column":7}}})) != null ? stack1 : "")
    + "<div class=\"spa-footnotes-section footnote-section__footnotes\"\r\n  data-aria-label-back=\""
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"footnoteSection") : stack1)) != null ? lookupProperty(stack1,"ariaLabelBack") : stack1), depth0)) != null ? stack1 : "")
    + "\"\r\n  data-back-content=\""
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"footnoteSection") : stack1)) != null ? lookupProperty(stack1,"backContent") : stack1), depth0)) != null ? stack1 : "")
    + "\"\r\n></div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"footnoteSectionToggleable") : stack1),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.program(12, data, 0),"data":data,"loc":{"start":{"line":25,"column":0},"end":{"line":31,"column":7}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate$4 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$4(data, options);
};

const Template$3 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"legal-section__bottom-section\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalBottomSection") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":4},"end":{"line":9,"column":11}}})) != null ? stack1 : "")
    + "  </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalBottomSection") : stack1)) != null ? lookupProperty(stack1,"text") : stack1),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":6},"end":{"line":8,"column":15}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "        <p>"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"legal-section__invest-section\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(12, data, 0),"data":data,"loc":{"start":{"line":16,"column":4},"end":{"line":60,"column":11}}})) != null ? stack1 : "")
    + "  </div>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <p class=\"legal-section__invest-title\">\r\n        "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"investText") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n      </p>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"tableRow1") : stack1),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":6},"end":{"line":29,"column":13}}})) != null ? stack1 : "")
    + "      <div class=\"legal-section__invest-text\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"bankText") : stack1),{"name":"each","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":8},"end":{"line":33,"column":17}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"mlText") : stack1),{"name":"each","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":8},"end":{"line":36,"column":17}}})) != null ? stack1 : "")
    + "      </div>\r\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <ul class=\"legal-section__invest-boxes\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"tableRow1") : stack1),{"name":"each","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":10},"end":{"line":24,"column":19}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"tableRow2") : stack1),{"name":"each","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":10},"end":{"line":27,"column":19}}})) != null ? stack1 : "")
    + "        </ul>\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "            <li>"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</li>\r\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "          "
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "\r\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <p class=\"legal-section__invest-title\">\r\n        "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"investText") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n      </p>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"tableRow1") : stack1),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":42,"column":6},"end":{"line":51,"column":13}}})) != null ? stack1 : "")
    + "      <div class=\"legal-section__invest-text\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"bankText") : stack1),{"name":"with","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":53,"column":8},"end":{"line":55,"column":17}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"mlText") : stack1),{"name":"with","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":56,"column":8},"end":{"line":58,"column":17}}})) != null ? stack1 : "")
    + "      </div>\r\n";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <ul class=\"legal-section__invest-boxes\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"tableRow1") : stack1),{"name":"each","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":44,"column":10},"end":{"line":46,"column":19}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"tableRow2") : stack1),{"name":"each","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":47,"column":10},"end":{"line":49,"column":19}}})) != null ? stack1 : "")
    + "        </ul>\r\n";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "          <p>"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"footerLegalBottomSection") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":0},"end":{"line":11,"column":7}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"investmentsSection") : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":0},"end":{"line":62,"column":7}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate$3 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$3(data, options);
};

const Template$2 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <p class=\"legal-section__invest-title\">\r\n          "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"customLegal1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"investText") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n        </p>\r\n        <ul class=\"legal-section__invest-boxes\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"customLegal1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"tableRow1") : stack1),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":10},"end":{"line":11,"column":19}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"customLegal1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"tableRow2") : stack1),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":10},"end":{"line":14,"column":19}}})) != null ? stack1 : "")
    + "        </ul>\r\n        <div class=\"legal-section__invest-text\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"customLegal1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"bankText") : stack1),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":10},"end":{"line":19,"column":19}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"customLegal1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"mlText") : stack1),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":10},"end":{"line":22,"column":19}}})) != null ? stack1 : "")
    + "        </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "            <li>"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</li>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "            <p>"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <p class=\"legal-section__invest-title\">\r\n          "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"investText") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n        </p>\r\n        <ul class=\"legal-section__invest-boxes\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"tableRow1") : stack1),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":10},"end":{"line":31,"column":19}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"tableRow2") : stack1),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":32,"column":10},"end":{"line":34,"column":19}}})) != null ? stack1 : "")
    + "        </ul>\r\n        <div class=\"legal-section__invest-text\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"bankText") : stack1),{"name":"with","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":37,"column":10},"end":{"line":39,"column":19}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1)) != null ? lookupProperty(stack1,"mlText") : stack1),{"name":"with","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":40,"column":10},"end":{"line":42,"column":19}}})) != null ? stack1 : "")
    + "        </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"expanded-legal-section__panel\">\r\n  <div class=\"row\">\r\n    <div class=\"column\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"customLegal1") : depth0)) != null ? lookupProperty(stack1,"footerLegalInvestSection") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(6, data, 0),"data":data,"loc":{"start":{"line":4,"column":6},"end":{"line":44,"column":13}}})) != null ? stack1 : "")
    + "    </div>\r\n  </div>\r\n</div>\r\n";
},"useData":true});
const renderTemplate$2 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$2(data, options);
};

const Template$1 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div id=\"legalSection\"  class=\"legal-section__panel\">\r\n    <div class=\"row small-collapse medium-uncollapse\">\r\n      <div class=\"column\">\r\n        <p><strong>"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalSection") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</strong></p>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerDisclosureSection") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(12, data, 0),"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":27,"column":15}}})) != null ? stack1 : "")
    + "      </div>\r\n    </div>\r\n  </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"isArray")||(depth0 && lookupProperty(depth0,"isArray"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerDisclosureSection") : stack1),{"name":"isArray","hash":{},"data":data,"loc":{"start":{"line":7,"column":16},"end":{"line":7,"column":61}}}),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(9, data, 0),"data":data,"loc":{"start":{"line":7,"column":10},"end":{"line":21,"column":17}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"legal-content"),(data && lookupProperty(data,"root")),{"name":"legal-content","data":data,"indent":"            ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerDisclosureSection") : stack1),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":12},"end":{"line":15,"column":21}}})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"contentKey") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":10,"column":14},"end":{"line":14,"column":21}}})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                "
    + ((stack1 = (lookupProperty(helpers,"spartaContentManagerHelper")||(depth0 && lookupProperty(depth0,"spartaContentManagerHelper"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"spartaContentManagerHelper","hash":{},"data":data,"loc":{"start":{"line":11,"column":16},"end":{"line":11,"column":53}}})) != null ? stack1 : "")
    + "\r\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                "
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "\r\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"legal-content"),(data && lookupProperty(data,"root")),{"name":"legal-content","data":data,"indent":"            ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerDisclosureSection") : stack1)) != null ? lookupProperty(stack1,"panels") : stack1),{"name":"each","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":12},"end":{"line":20,"column":21}}})) != null ? stack1 : "");
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":19,"column":14},"end":{"line":19,"column":27}}}) : helper))) != null ? stack1 : "")
    + "\r\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"legal-content"),(data && lookupProperty(data,"root")),{"name":"legal-content","data":data,"indent":"          ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"footerDisclosureSection") : stack1)) != null ? lookupProperty(stack1,"panels") : stack1),{"name":"each","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":10},"end":{"line":26,"column":19}}})) != null ? stack1 : "");
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":25,"column":12},"end":{"line":25,"column":25}}}) : helper))) != null ? stack1 : "")
    + "\r\n";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div id=\"legalSection\" class=\"legal-section__panel\">\r\n    <div class=\"row\">\r\n      <div class=\"column\">\r\n        <p><strong>"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"globalFooter1") : depth0)) != null ? lookupProperty(stack1,"footerLegalSection") : stack1)) != null ? lookupProperty(stack1,"title") : stack1), depth0)) != null ? stack1 : "")
    + "</strong></p>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerDisclosureSection") : stack1),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.program(12, data, 0),"data":data,"loc":{"start":{"line":36,"column":8},"end":{"line":59,"column":15}}})) != null ? stack1 : "")
    + "      </div>\r\n    </div>\r\n  </div>\r\n";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div class=\"legal-section__custom-disclosure\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(lookupProperty(helpers,"isArray")||(depth0 && lookupProperty(depth0,"isArray"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerDisclosureSection") : stack1),{"name":"isArray","hash":{},"data":data,"loc":{"start":{"line":38,"column":18},"end":{"line":38,"column":63}}}),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.program(23, data, 0),"data":data,"loc":{"start":{"line":38,"column":12},"end":{"line":52,"column":19}}})) != null ? stack1 : "")
    + "          </div>\r\n";
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"legal-content"),(data && lookupProperty(data,"root")),{"name":"legal-content","data":data,"indent":"              ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerDisclosureSection") : stack1),{"name":"each","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":40,"column":14},"end":{"line":46,"column":23}}})) != null ? stack1 : "");
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"contentKey") : depth0),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.program(21, data, 0),"data":data,"loc":{"start":{"line":41,"column":16},"end":{"line":45,"column":23}}})) != null ? stack1 : "");
},"19":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  "
    + ((stack1 = (lookupProperty(helpers,"spartaContentManagerHelper")||(depth0 && lookupProperty(depth0,"spartaContentManagerHelper"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"spartaContentManagerHelper","hash":{},"data":data,"loc":{"start":{"line":42,"column":18},"end":{"line":42,"column":55}}})) != null ? stack1 : "")
    + "\r\n";
},"21":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                  "
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "\r\n";
},"23":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"legal-content"),(data && lookupProperty(data,"root")),{"name":"legal-content","data":data,"indent":"              ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"footerDisclosureSection") : stack1)) != null ? lookupProperty(stack1,"panels") : stack1),{"name":"each","hash":{},"fn":container.program(24, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":49,"column":14},"end":{"line":51,"column":23}}})) != null ? stack1 : "");
},"24":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":50,"column":16},"end":{"line":50,"column":29}}}) : helper))) != null ? stack1 : "")
    + "\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"mode") : stack1),"==","unauth",{"name":"compare","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(15, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":63,"column":12}}})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <nav class=\"collapsed\" id=\"links-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"index") || (data && lookupProperty(data,"index"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data,"loc":{"start":{"line":11,"column":45},"end":{"line":11,"column":55}}}) : helper)))
    + "\" aria-label=\""
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data,"loc":{"start":{"line":11,"column":69},"end":{"line":11,"column":80}}}) : helper))) != null ? stack1 : "")
    + "\">\r\n              <h3>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"label","hash":{},"data":data,"loc":{"start":{"line":12,"column":18},"end":{"line":12,"column":29}}}) : helper))) != null ? stack1 : "")
    + "</h3>\r\n              <div class=\"power-footer__links\" id=\"footer-links-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"index") || (data && lookupProperty(data,"index"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data,"loc":{"start":{"line":13,"column":64},"end":{"line":13,"column":74}}}) : helper)))
    + "\">\r\n                "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":14,"column":16},"end":{"line":14,"column":29}}}) : helper))) != null ? stack1 : "")
    + "\r\n              </div>\r\n            </nav>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"footer__power-footer "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"powerFooterClass") : stack1), depth0))
    + "\">\r\n  <div class=\"row collapse\">\r\n    <div class=\"column\">\r\n      <div class=\"show-for-small-only\">\r\n        "
    + container.escapeExpression((lookupProperty(helpers,"squeezebox")||(depth0 && lookupProperty(depth0,"squeezebox"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"partials") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"powerFooterSection") : stack1),{"name":"squeezebox","hash":{},"data":data,"loc":{"start":{"line":5,"column":8},"end":{"line":5,"column":62}}}))
    + "\r\n      </div>\r\n\r\n      <div class=\"show-for-medium-up\">\r\n        <div class=\"footer__power-list\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"siteFooter1") : depth0)) != null ? lookupProperty(stack1,"powerFooterSection") : stack1)) != null ? lookupProperty(stack1,"panels") : stack1),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":10},"end":{"line":17,"column":19}}})) != null ? stack1 : "")
    + "        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

/* eslint-disable no-param-reassign */

/**
   * {{footerModuleLinksHelper}}
   * This is a clone of footerLinksHelper in the footer-assisted-module.
   * Creates a final footer link object based on global links & order and a site level override.
   * @param {sting[]} globalLinkOrder Array of strings indicating global/default order of links
   * @param {Object[]} globalLinks Array of global link config objects (id, name, url, etc)
   * @param {sting[]} siteLinkOrder Site-specific overrides for footer links & display order
   * @param {Object[]} siteLinks Array of site-specific link config objects.
   *                             Anything not passed in will inherit from globalLinkOrder
   *
   * @return {Object} Handlebars.SafeString object
   */
function footerModuleLinksHelper(globalLinkOrder, globalLinks, siteLinkOrder, siteLinks) {
  // merge site footer links over global links
  const links = {
    ...globalLinks,
    ...siteLinks
  };
  const finalFooterLinks = {};

  // set order of links from site or use global list
  const linkOrder = typeof siteLinkOrder === 'object' && siteLinkOrder.length > 0 ? siteLinkOrder : globalLinkOrder;

  // For each link in linkOrder, grab that link object out of links and add to finalFooterLinks
  linkOrder.forEach(link => {
    finalFooterLinks[link] = links[link];
  });

  // return new Handlebars.SafeString(r);
  return finalFooterLinks;
}

/**
   * Determines if an object's length is greater than or equal to a given number.
   * @param {object} object - The object to analyze.
   * @param {number} greaterNum - The length to check against.
   * @param {string} removeKey - A key to optionally remove from the object.
   * @returns {boolean} Whether the length is greater than or equal to a given number.
   */
function objLengthGreaterEqualThan(object, greaterNum, removeKey) {
  // kill check
  if (!object) {
    return false;
  }

  // remove key from object to check length
  if (removeKey) {
    delete object[removeKey];
  }

  // check length
  return Object.keys(object).length >= greaterNum;
}

/**
   * Add two numbers together
   * @param {...number} numbers - List of numbers to add together
   * @returns {number} The sum of provided numbers
   */
function sum(...numbers) {
  return [...numbers].filter(number => typeof number === 'number').reduce((total, num) => total + num);
}

/**
 * Checks if provided param is an array
 * @param {*} param Data to test against
 * @returns {Boolean} True if array, false if not
 */
function isArray(param) {
  if (typeof param === 'object' && Array.isArray(param) && param !== null) {
    return true;
  }
  return false;
}

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.global-gt.modules/global-footer-module",
  "version": "1.1.27",
  "id": "globalFooterModule",
  "containerID": "globalGtGlobalFooterModule",
  "moduleName": "global-gt-global-footer-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "global-footer-module",
  "data": {
    "init": "GlobalFooterModule"
  },
  "moduleParams": [{
    "name": "skin",
    "type": "string",
    "values": ["consumer", "consumer-legacy", "smallbusiness", "unified"],
    "default": "unified",
    "description": "Selects a color scheme for the footer"
  }, {
    "name": "mode",
    "type": "string",
    "values": ["auth", "unauth"],
    "default": "auth",
    "description": "Flags footer set as auth or unauth"
  }, {
    "name": "footnoteSection",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "Enable/disable footnote information section"
  }, {
    "name": "footnoteSectionToggleable",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Enable/disable footnote toggleable state"
  }, {
    "name": "footnoteExpandOnLoad",
    "type": "object",
    "values": {
      "small": false,
      "medium": false,
      "large": true,
      "xlarge": true
    },
    "default": {
      "small": false,
      "medium": false,
      "large": true,
      "xlarge": true
    },
    "description": "Should the footnote section be expanded on load"
  }, {
    "name": "legalSection",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Enable/disable legal information section"
  }, {
    "name": "legalExpandOnLoad",
    "type": "object",
    "values": {
      "small": false,
      "medium": false,
      "large": true,
      "xlarge": true
    },
    "default": {
      "small": false,
      "medium": false,
      "large": true,
      "xlarge": true
    },
    "description": "Should the Legal section be expanded on load?"
  }, {
    "name": "footerLegalBottomSection",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Enable/disable footerBottom section text list in Legal section of footer"
  }, {
    "name": "footerActions",
    "type": "object",
    "values": {
      "enabled": true,
      "secure_area": true,
      "language_select": true,
      "authentication": true
    },
    "default": {
      "enabled": false,
      "secure_area": true,
      "language_select": true,
      "authentication": true
    },
    "description": "Should the footer display `secure area`, `language select` or `login/logout` sections"
  }, {
    "name": "footerActions_language",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "Footer language options NOTE: turn to default"
  }, {
    "name": "copyrightSection",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "Should the copyright section at the bottom be displayed"
  }, {
    "name": "investmentsSection",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Enable/disable investment disclosure section"
  }, {
    "name": "breadcrumbs",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Enable/disable breadcrumb section"
  }, {
    "name": "breadcrumbsCurrentPage",
    "type": "boolean",
    "default": true,
    "description": "Include the current page as last item in breadcrumb list"
  }, {
    "name": "breadcrumbsClass",
    "type": "string",
    "default": "",
    "description": "Use media query classes such as show-for-large-up."
  }, {
    "name": "breadcrumbsSectionName",
    "type": "string",
    "default": "",
    "description": "Key to match against `sectionLinks` object in `siteFooter1` JCR."
  }, {
    "name": "expandedLegalSection",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Expanded LegalSection"
  }, {
    "name": "footerQuickLink",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "Enable list of links in footer seperated by pipes (link | link | link)"
  }, {
    "name": "footerQuickLinkClass",
    "type": "string",
    "default": "",
    "description": "Optional class used for this DOM section"
  }, {
    "name": "powerFooterSection",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Enable/disable power footer section"
  }, {
    "name": "powerFooterClass",
    "type": "string",
    "default": "",
    "description": "Use media query classes such as show-for-large-up."
  }, {
    "name": "enableSocialMedia",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "Enable/disable social media icons in footer"
  }, {
    "name": "setFooterSpacingTop",
    "type": "string",
    "values": ["margin", "padding", "none"],
    "default": "margin",
    "description": "Set spacing above footer module"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$8(context, {
      "helpers": {
        objLengthGreaterEqualThan,
        sum,
        footerModuleLinksHelper,
        isArray,
        spartaContentManagerHelper,
        squeezebox,
        link,
        layerContent,
        or,
        compare,
        button
      },
      "partials": {
        "actions": renderTemplate$7,
        "breadcrumbs": renderTemplate$6,
        "footer-quicklinks": renderTemplate$5,
        "footnote": renderTemplate$4,
        "legal-content": renderTemplate$3,
        "legal-expanded": renderTemplate$2,
        "legal": renderTemplate$1,
        "power-footer": renderTemplate
      }
    });
  },
  "template": renderTemplate$8,
  "partials": {
    "actions": renderTemplate$7,
    "breadcrumbs": renderTemplate$6,
    "footer-quicklinks": renderTemplate$5,
    "footnote": renderTemplate$4,
    "legal-content": renderTemplate$3,
    "legal-expanded": renderTemplate$2,
    "legal": renderTemplate$1,
    "power-footer": renderTemplate
  },
  "helpers": {
    objLengthGreaterEqualThan,
    sum,
    footerModuleLinksHelper,
    isArray,
    spartaContentManagerHelper,
    squeezebox,
    link,
    layerContent,
    or,
    compare,
    button
  },
  "dependencies": {
    "@sparta.global.helpers/content-manager-helper": "^1.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.3",
    "@sparta.global.helpers/sparta-helper": "^1.0.5",
    "@sparta.global.helpers/squeezebox-helper": "^1.0.2",
    "@sparta.global.helpers/button-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-footnote-utility": "^1.0.5",
    "@sparta.global.utilities/sparta-global-functions-utility": "^1.0.3",
    "@sparta.global.utilities/sparta-mediaquery-utility": "^1.0.3",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.7",
    "@sparta.global.utilities/sparta-squeezebox-utility": "^1.0.6",
    "@sparta.global.utilities/sparta-store-utility": "^1.0.3",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.4",
    "@sparta.global.vendors/handlebars": "^4.7.7"
  },
  "stores": []
};

/* global bactm Module spartaFootnoteUtility spartaMediaQueryUtility spartaSqueezeboxUtility */

const selectors = {
  footnoteSection: '#footnoteSection',
  footnoteSectionContent: '.footnote-section__footnotes',
  legalSection: '#legalSection',
  legalBottomSection: '.legal-section__bottom-section',
  legalInvestSection: '.legal-section__invest-section',
  panelHeader: '.panel-header',
  panelContent: '.panel-content',
  bottomLinks: '.footer__bottom-links a',
  feedbackLink: '#footer_bofa_feedback'
};
const cssClasses = {
  squeezeboxWrapper: 'squeezebox-wrapper',
  mdaHide: 'mda-hide'
};

/**
 * Class providing interactive features for the Footer.
 */
class GlobalFooterModule extends Module {
  /**
   * Adds event listeners and call initialization functions.
   * @returns {void}
   */
  init() {
    const {
      target
    } = this.settings;

    // If the Footnote section is collapsible, move all its content into its squeezebox.
    const footnoteSection = target.querySelector(selectors.footnoteSection);
    if (footnoteSection && footnoteSection.classList.contains(cssClasses.squeezeboxWrapper)) {
      const footnoteSectionPanel = footnoteSection.querySelector(selectors.panelContent);
      const footnoteSectionContent = target.querySelector(selectors.footnoteSectionContent);
      if (footnoteSectionContent) {
        footnoteSectionPanel.appendChild(footnoteSectionContent);
      }
    }

    // Activate any squeezeboxes present.
    spartaSqueezeboxUtility.init();

    // Expand collapsible sections on load where appropriate.
    this.Events.sub(spartaSqueezeboxUtility.EVENTS.SQUEEZEBOX_READY, payload => {
      let payLoadData = payload?.data?.includes;
      if (typeof payLoadData != 'undefined' && payLoadData != null) {
        if (payload.data.includes('footnoteSection')) {
          this.initCollapsibleSection(footnoteSection, this.params.footnoteExpandOnLoad);
        }
      }
    }, true);

    // Reset collapsible sections on breakpoint change.
    this.Events.sub(spartaMediaQueryUtility.EVENTS.BREAKPOINT_CHANGE, () => {
      this.initCollapsibleSection(footnoteSection, this.params.footnoteExpandOnLoad);
    });

    // Ensure the Footnote section is expanded on footnote click.
    this.Events.sub(spartaFootnoteUtility.EVENTS.FOOTNOTE_CLICKED, this.expandSection.bind(this, footnoteSection));

    // For MDA, hide any non-secure links.
    this.mdaHideNonSecureLinks();
    this.updatePatentURL();
    this.updateLabelingForLinks();

    // Activate the Feedback link.
    const feedbackLink = target.querySelector(selectors.feedbackLink);
    if (feedbackLink) {
      let feedAda = document.documentElement.lang === "es-US" ? 'Comparta sus comentarios. Se abre en una ventana modal ' : 'Share Your Feedback . Opening in a modal dialog';
      feedbackLink.setAttribute('aria-label', feedAda);
      feedbackLink.setAttribute('role', 'button');
      feedbackLink.addEventListener('click', GlobalFooterModule.launchFeedback);
    }

    // Remove the ADA text for Advertising Practices link
    var element = document.querySelector("#footer_bofa_advetising_practices");
    if (element) {
      var spanElement = element.getElementsByTagName("span")[0];
      if (spanElement) {
        spanElement.remove();
      }
    }

    // ADA fix for Browse With Specialist.
    const browseWithSpecialist = document.querySelector('#cobrowse');
    if (browseWithSpecialist) {
      browseWithSpecialist.setAttribute('role', 'button');
    }

    // ADA Changes for Equal Housing Lender
    const equalhousingLender = document.querySelector("#equalHousingLender");
    if (equalhousingLender) {
      let ehlAda = document.documentElement.lang === "es-US" ? "Igualdad de oportunidades en pr&eacute;stamos para viviendas. Se abre en una ventana modal" : "Equal Housing Lender . Open in a modal dialog";
      equalhousingLender.setAttribute('aria-label', ehlAda);
    }

    // Set Privacy Security Links Appropriately
    this.setPrivacySecurityTargets();

    //utagcheck
    var utagCheck = setInterval(() => {
      if (typeof Optanon != "undefined") {
        clearInterval(utagCheck);
        setTimeout(() => {
          this.oneTrustCallback();
          return;
        }, 300);
      }
    }, 100);
    if (document.readyState === 'complete') {
      //clear setinterval if utag value is not fetched in 60sec
      setTimeout(() => {
        clearInterval(utagCheck);
      }, 60000);
    }
  }

  /**
   * General function for all ADA fixes.
   * @returns {void}
   */
  updateLabelingForLinks() {
    // Adding aria-lable to all link which open in new window.
    [...document.querySelectorAll('#footer_bofa_childrens_privacy, #footer_bofa_online_banking_service_agreement, #footerPatent')].forEach(anchor => {
      if (anchor.getAttribute('target') === '_blank') {
        const showResult = anchor.textContent.trim();
        const setAnchor = document.documentElement.lang === 'es-US' ? `${showResult} . Abra en una nueva ventana.` : `${showResult} .Open in new window`;
        anchor.setAttribute('aria-label', setAnchor);
      }
    });
    const patentElem = document.getElementById('footerPatent');
    if (patentElem) {
      const patentLabel = document.documentElement.lang === 'es-US' ? 'Patente: patents.bankofamerica.com. Abra en una nueva ventana.' : 'Patent: patents.bankofamerica.com .Open in new window';
      patentElem.setAttribute('aria-label', patentLabel);
    }
  }
  oneTrustCallback() {
    var pillImg = document.getElementById('pillImage');
    if (pillImg === undefined || pillImg === null || pillImg.getAttribute('src') === null || pillImg.getAttribute('src') === "") return;
    pillImg.style.display = 'inline-block';
  }

  /**
  * Initialize privacy targets
  */
  setPrivacySecurityTargets() {
    // get privacy / security links / equalhousinglender links
    [...document.querySelectorAll('.footer-privacy-link, .footer-security-link, #equalHousingLender, #footer_bofa_accessible_banking, #footer_bofa_sitemap, #Online-privacy-faqs, #footer_bofa_childrens_privacy, #footer_bofa_online_banking_service_agreement')].forEach(link => {
      let path = link.href;
      path = path.replace('//secure', '//www');
      link.href = path;
    });
  }

  /**
   * Conditionally expands a given section based on the module configuration and current viewport.
   * @param {object} sectionEl - The DOM node of the (possibly) collapsible section.
   * @param {object} [expandOnLoad] - A set of flags indicating whether to expand the section on
   *   load for a given viewport: `small`, `medium`, `large`, and `xlarge`.
   * @returns {void}
   */
  initCollapsibleSection(sectionEl, expandOnLoad = {}) {
    if (!sectionEl) {
      return;
    }
    const panelHeader = sectionEl.querySelector(selectors.panelHeader);
    if (!panelHeader) {
      return;
    }

    // Determine if the section is currently collapsed or expanded.
    const isExpanded = panelHeader.getAttribute('aria-expanded') === 'true';

    // Determine if the section should be expanded based on the current viewport.
    let {
      viewport
    } = spartaStoreUtility.getData('currentMQ');
    let unexpectedViewport = !Object.prototype.hasOwnProperty.call(expandOnLoad, viewport);
    if (unexpectedViewport && ['smallMid', 'smallPlus'].includes(viewport)) {
      viewport = 'small';
      unexpectedViewport = false;
    }
    const shouldBeExpanded = unexpectedViewport || expandOnLoad[viewport];

    // Expand or collapse the section as needed.
    if (isExpanded !== shouldBeExpanded) {
      panelHeader.click();
    }
  }

  /**
   * Expands a given collapsible section.
   * @param {object} sectionEl - The DOM node of the (possibly) collapsible section.
   * @returns {void}
   */
  expandSection(sectionEl) {
    if (!sectionEl) {
      return;
    }
    const panelHeader = sectionEl.querySelector(selectors.panelHeader);
    if (!panelHeader) {
      return;
    }

    // Expand the section if it is currently collapsed.
    const isExpanded = panelHeader.getAttribute('aria-expanded') === 'true';
    if (!isExpanded) {
      panelHeader.click();
    }
  }

  /**
   * When needed, adds the `mda-hide` class to any non-secure links in the bottom nav.
   * @returns {void}
   */
  mdaHideNonSecureLinks() {
    if (document.documentElement.classList.contains('mda')) {
      const nonSecureLinks = [...this.settings.target.querySelectorAll(`${selectors.bottomLinks}[href^="http://"]`)];
      if (nonSecureLinks.length) {
        requestAnimationFrame(() => {
          nonSecureLinks.forEach(link => {
            link.parentNode.classList.add(cssClasses.mdaHide);
          });
        });
      }
    }
  }
  updatePatentURL() {
    const currentURL = document.location.href;
    const env = currentURL.split('-')[1];
    let patentURL = "";
    if (currentURL.includes('helix')) {
      patentURL = `https://www-${env}-helix.ecnp.bankofamerica.com/company/patents/`;
    } else {
      patentURL = "https://patents.bankofamerica.com";
    }
    const patentEl = document.querySelector("#footerPatent");
    if (null !== patentEl) {
      patentEl.setAttribute('href', patentURL);
    }
  }

  /**
   * Launches the Feedback modal.
   * @param {object} event - Click event.
   * @returns {void}
   */
  static launchFeedback(event) {
    event.preventDefault();
    try {
      bactm.plugins.feedback.launch();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  }
}
registerModuleClass({
  moduleClass: GlobalFooterModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { GlobalFooterModule as default, moduleConfig };
